<template>
  <div id="app">
    <Head v-if="isShow"></Head>
    <router-view style="min-height:80vh; overflow:hidden;"></router-view>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from './components/myHead'
import Foot from './components/myFoot'
export default {
  name: 'App',
  data(){
    return{
      isShow: true,
      isAbout:false
    }
  },
  components: {
     Head,
     Foot,
  },
  watch:{
    $route(to,from){
      if(to.path == ''){
        
      }else{
        this.isShow = true;
      }
    }
  },
  mounted(){
    if(this.$route.path == '/aboutus'   ){
      this.isShow = false;
    }else{
      this.isShow = true;
    }
  },
  methods: {

  },
  created(){

  }
}
</script>
<style>
 @import url('../node_modules/element-ui/lib/theme-chalk/index.css');
 #app{ min-height: 100vh;}
</style>

<style>
html,body{
    margin: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }
  #app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue